const localUrl = {
    APIURL: 'https://24gsr.ru:8000'
}

export {localUrl};
